import api from '../api';
import { toastSuccess, toastError } from '../../toasts';

class NeighborhoodService {
  static async create(data) {
    try {
      if (!data || Object.keys(data).length === 0) return;

      const response = await api.post('bairro/criar', data);

      toastSuccess('Bairro cadastrado');
      return response.data;
    } catch (error) {
      toastError('Não foi possivel cadastrar bairro');
      console.log(error);
    }
  }

  static async update(id = '', data) {
    try {
      if (!id) return false;

      const response = await api.patch(`bairro/alterar/${id}`, data);
      toastSuccess('Bairro foi alterado');

      return response.data;
    } catch (error) {
      toastError('Não foi possivel alterar o bairro');
      console.log(error);
      return false;
    }
  }
}

export { NeighborhoodService };
